var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { reaction } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useIntervalTimer } from 'ziphy-web-shared/basic/hooks';
import { globalLoaderHandlers, useLoaderSubscribe } from 'ziphy-web-shared/basic/utils';
import { $time } from 'ziphy-web-shared/basic/utils/time';
import styles from './Calendar.module.scss';
import { $calendar } from './Calendar.store';
import StickyHeader from './stickyHeader/StickyHeader';
import TableContent from './table/tableContent/TableContent';
const Calendar = () => {
    useEffect(() => () => $calendar.clearFull(), []);
    useEffect(() => {
        $calendar.init($time.timezone, $time.weekType);
        const disposers = [
            reaction(() => $calendar.isMobile || $calendar.isDay, () => $calendar.init($time.timezone, $time.weekType)),
            reaction(() => $calendar.isChangedRange, (newVal) => newVal && $calendar.loadData()),
        ];
        return () => disposers.forEach((fn) => fn());
    }, [$time.timezone]);
    // todo: remove useIntervalTimer and use only eventsListener
    useIntervalTimer({
        callback: () => __awaiter(void 0, void 0, void 0, function* () { return yield $calendar.loadData(false); }),
        duration: 90000,
    });
    useLoaderSubscribe(globalLoaderHandlers.EVENT, (message) => __awaiter(void 0, void 0, void 0, function* () {
        if (message.isChatMessage)
            return;
        yield $calendar.loadData(false);
    }));
    if (!$calendar.isInitialized) {
        return _jsx(_Fragment, {});
    }
    return (_jsxs("div", Object.assign({ className: styles.calendar }, { children: [_jsx(StickyHeader, { isLoading: $calendar.isLoading }), _jsx("div", Object.assign({ className: "container" }, { children: _jsx(TableContent, { isLoading: $calendar.isLoading }) }))] })));
};
export default observer(Calendar);
